// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import companyLogo,{} from "../../../src/assets/images/Final logo.png";
// import "../../../src/assets/css/salesvsexpense.css";

// function SalesVsExpense() {
//   const navigate = useNavigate();
//   const { date } = useParams();
//   const companyLogoUrl = companyLogo;
//   const location = useLocation();

//   const [paymentModal, setPaymentModal]   = useState(false);
//   const [infoModal, setInfoModal]         = useState(false);
//   const [responseData, setResponseData]   = useState(null);
//   const [paymentAmount, setPaymentAmount] = useState("");
//   const [paymentType, setPaymentType]     = useState("");
//   const [paymentManager, setPaymentManager] = useState(""); // which manager is handing this amount to Admin
//   const [allManagers, setAllManagers]     = useState([]);
//   const [payments, setPayments]           = useState([]);
//   const [responseSalesData, setResponseSalesData] = useState([]);
//   const [exchangeData, setExchangeData]   = useState([]);

//   const [expenseData, setExpenseData] = useState([]);
//   const [gpayData, setGpayData]       = useState([]);
//   const [loanData, setLoanData]       = useState([]);
//   const [chitData, setChitData]       = useState([]);

//   // ── real data sources for the four sections that are NOT sales_items.action_type rows ──
//   const [retailerBalanceData, setRetailerBalanceData] = useState([]);
//   const [orderAdvanceData,    setOrderAdvanceData]    = useState([]);
//   const [orderCompleteData,   setOrderCompleteData]   = useState([]);

//   const [showSalesTable,    setShowSalesTable]    = useState(false);
//   const [showPoSalesTable,  setShowPoSalesTable]  = useState(false);
//   const [showOldSalesTable, setShowOldSalesTable] = useState(false);
//   const [showExpenseTable,  setShowExpenseTable]  = useState(false);
//   const [showGpayTable,     setShowGpayTable]     = useState(false);
//   const [showLoanTable,     setShowLoanTable]     = useState(false);
//   const [showChitTable,     setShowChitTable]     = useState(false);
//   const [showExchangeTable, setShowExchangeTable] = useState(false);

//   // ── toggle state for Sales Balance / Retailer Balance / Order Advance / Order Complete ──
//   const [showSalesBalanceTable,    setShowSalesBalanceTable]    = useState(false);
//   const [showRetailerBalanceTable, setShowRetailerBalanceTable] = useState(false);
//   const [showOrderAdvanceTable,    setShowOrderAdvanceTable]    = useState(false);
//   const [showOrderCompleteTable,   setShowOrderCompleteTable]   = useState(false);

//   const openPaymentModal  = () => setPaymentModal(true);
//   const closePaymentModal = () => { setPaymentModal(false); setPaymentManager(""); setPaymentType(""); setPaymentAmount(""); };
//   const openInfoModal     = () => setInfoModal(true);
//   const closeInfoModal    = () => setInfoModal(false);

//   // ── Manager filter. Comes from the list page (router state or ?manager=
//   // query param) whenever the user filtered the list by a manager before
//   // clicking Edit. Known immediately, before responseData loads, so it can
//   // be used right away to scope the data fetches below. ──
//   const queryManager = new URLSearchParams(location.search).get("manager");
//   const managerFilter = location.state?.manager || queryManager || "";
//   const hasManagerFilter = Boolean(managerFilter);

//   // Manager name for the top-right badge — only ever shown when the page was
//   // opened via a manager filter. Prefer the value that comes straight off the
//   // record itself (sales_vs_expense.php echoes back the filtered `manager`),
//   // falling back to whatever was passed in from the list page.
//   const managerName = responseData?.manager || managerFilter;

//   // const handlePrint = () => {
//   //   // The print layout (.print-columns) renders every section's data
//   //   // unconditionally already, so it never depended on the on-screen
//   //   // accordion toggles below — forcing them all open here only left
//   //   // the screen view messed up after printing, without fixing print.
//   //   window.print();
//   // };


//   const handlePrint = () => {
//   const w = window.open("", "_blank", "width=1200,height=800");
//   if (!w) {
//     alert("Please allow popups for this site to print.");
//     return;
//   }

//   const fmtCur = formatCurrency;
//   const fmtDate = formatDate;

//   const rowsHtml = (data) => {
//     if (!data || data.length === 0) return "";
//     return `
//       <table>
//         <thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Item</th><th>Wt</th><th>Rate</th><th>Amt</th></tr></thead>
//         <tbody>
//           ${data.map((e, i) => `
//             <tr>
//               <td>${i + 1}</td>
//               <td>${e.sale_id ?? "-"}</td>
//               <td>${e.customer_name ?? "-"}</td>
//               <td>${e.item_name ?? "-"}</td>
//               <td>${e.weight ?? "-"}</td>
//               <td>₹${fmtCur(e.rate)}</td>
//               <td>₹${fmtCur(e.amount)}</td>
//             </tr>`).join("")}
//         </tbody>
//       </table>`;
//   };

//   const gpayRowsHtml = gpayData.length === 0 ? "" : `
//     <table>
//       <thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Type</th><th>Date</th><th>Value</th></tr></thead>
//       <tbody>
//         ${gpayData.map((g, i) => `
//           <tr>
//             <td>${i + 1}</td><td>${g.sale_id}</td><td>${g.customer_name}</td>
//             <td>${g.pay_type}</td><td>${fmtDate(g.txn_date)}</td><td>₹${fmtCur(g.value)}</td>
//           </tr>`).join("")}
//       </tbody>
//     </table>`;

//   const expenseRowsHtml = expenseData.length === 0 ? "" : `
//     <table>
//       <thead><tr><th>S.No</th><th>Exp No</th><th>Type</th><th>Description</th><th>Date</th><th>Amount</th></tr></thead>
//       <tbody>
//         ${expenseData.map((e, i) => `
//           <tr>
//             <td>${i + 1}</td><td>${e.id}</td><td>${e.type}</td>
//             <td>${e.description}</td><td>${fmtDate(e.date)}</td><td>₹${fmtCur(e.amount)}</td>
//           </tr>`).join("")}
//       </tbody>
//     </table>`;

//   const loanRowsHtml = loanData.length === 0 ? "" : `
//     <table>
//       <thead><tr><th>S.No</th><th>Loan ID</th><th>Customer</th><th>Category</th><th>Amount</th></tr></thead>
//       <tbody>
//         ${loanData.map((l, i) => `
//           <tr>
//             <td>${i + 1}</td><td>${l.loan_id}</td><td>${l.customer?.customer_name ?? "-"}</td>
//             <td>${l.loan_list?.[0]?.category ?? "-"}</td><td>₹${fmtCur(l.loan_amount)}</td>
//           </tr>`).join("")}
//       </tbody>
//     </table>`;

//   const chitRowsHtml = chitData.length === 0 ? "" : `
//     <table>
//       <thead><tr><th>S.No</th><th>Chit ID</th><th>Customer</th><th>Duration</th><th>Amount</th></tr></thead>
//       <tbody>
//         ${chitData.map((c, i) => `
//           <tr>
//             <td>${i + 1}</td><td>${c.chit_id}</td><td>${c.name ?? "-"}</td>
//             <td>${c.duration}</td><td>₹${fmtCur(c.amount)}</td>
//           </tr>`).join("")}
//       </tbody>
//     </table>`;

//   const html = `
// <!DOCTYPE html>
// <html>
// <head>
// <meta charset="utf-8" />
// <title>Transaction Overview - ${fmtDate(date)}</title>
// <style>
//   @page { size: A5 landscape; margin: 8mm; }
//   * { box-sizing: border-box; }
//   body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; color: #000; }

//   .co-header {
//     display: flex; justify-content: space-between; align-items: center;
//     border-bottom: 2px solid #000; padding-bottom: 5px; margin-bottom: 5px;
//   }
//   .co-logo { width: 90px; height: 55px; object-fit: contain; }
//   .co-details { flex: 1; text-align: center; }
//   .co-details h2 { margin: 0; font-size: 16px; }
//   .co-details p { margin: 2px 0; font-size: 10px; }
//   .co-title { font-size: 13px; font-weight: bold; text-align: right; }
//   .co-manager { display: block; margin-top: 3px; font-size: 10px; }

//   .print-header {
//     text-align: center; font-weight: bold;
//     border-top: 1px solid #000; border-bottom: 1px solid #000;
//     padding: 4px; margin-bottom: 8px; font-size: 13px;
//   }

//   .print-columns { display: table; width: 100%; table-layout: fixed; border-spacing: 8px 0; }
//   .print-col { display: table-cell; width: 50%; vertical-align: top; border: 1px solid #666; padding: 6px; }

//   .print-section-title {
//     color: #0d6efd; font-size: 12px; font-weight: bold;
//     border-bottom: 1px solid #0d6efd; margin-bottom: 5px; padding-bottom: 3px;
//   }

//   .print-row {
//     display: flex; justify-content: space-between;
//     border-bottom: 1px dotted #bbb; padding: 3px 0; font-size: 10px;
//   }
//   .print-row .label { font-weight: bold; }

//   .print-total {
//     display: flex; justify-content: space-between;
//     border-top: 2px solid #000; margin-top: 5px; padding-top: 5px;
//     font-weight: bold; font-size: 11px;
//   }

//   table { width: 100%; border-collapse: collapse; font-size: 9px; margin: 4px 0 8px; table-layout: fixed; }
//   table th, table td { border: 1px solid #999; padding: 2px 3px; overflow: hidden; word-break: break-word; }
//   table th:last-child, table td:last-child { width: 18%; white-space: nowrap; text-align: right; }
//   table th:nth-child(1), table td:nth-child(1) { width: 6%; }
//   table th:nth-child(2), table td:nth-child(2) { width: 14%; }
//   thead { display: table-header-group; }
//   tr { page-break-inside: avoid; }
// </style>
// </head>
// <body>

//   <div class="co-header">
//     <img class="co-logo" src="${window.location.origin}${companyLogoUrl}" onerror="this.style.display='none'" />
//     <div class="co-details">
//       <h2>TIRUPUR JEWELLERY</h2>
//       <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
//       <p>Ph: 04272233807</p>
//     </div>
//     <div class="co-title">
//       TXN OVERVIEW
//       ${hasManagerFilter ? `<span class="co-manager">Manager: ${managerName}</span>` : ""}
//     </div>
//   </div>

//   <div class="print-header">Transaction Overview — ${fmtDate(date)}</div>

//   <div class="print-columns">
//     <div class="print-col">
//       <div class="print-section-title">Sales</div>

//       <div class="print-row"><span class="label">Sales</span><span>₹ ${fmtCur(responseData?.sales)}</span></div>
//       ${rowsHtml(salesData)}

//       <div class="print-row"><span class="label">PO Sales</span><span>₹ ${fmtCur(responseData?.po_sales)}</span></div>
//       ${rowsHtml(poSalesData)}

//       <div class="print-row"><span class="label">Old Sales</span><span>₹ ${fmtCur(responseData?.old_sales)}</span></div>
//       ${rowsHtml(oldSalesData)}

//       <div class="print-row"><span class="label">Sales Balance</span><span>₹ ${fmtCur(responseData?.sales_balance)}</span></div>
//       ${rowsHtml(salesBalanceData)}

//       <div class="print-row"><span class="label">Retailer Balance</span><span>₹ ${fmtCur(responseData?.retailer_balance)}</span></div>
//       ${rowsHtml(retailerBalanceData)}

//       <div class="print-row"><span class="label">Order Advance</span><span>₹ ${fmtCur(responseData?.order_advance)}</span></div>
//       ${rowsHtml(orderAdvanceData)}

//       <div class="print-row"><span class="label">Order Complete</span><span>₹ ${fmtCur(responseData?.order_complete)}</span></div>
//       ${rowsHtml(orderCompleteData)}

//       ${addData.l_s_repair_value1 ? `<div class="print-row"><span class="label">L.S. Repair</span><span>₹ ${fmtCur(addData.l_s_repair_value1)}</span></div>` : ""}
//       ${addData.l_s_repair_text && addData.l_s_repair_value2 ? `<div class="print-row"><span class="label">${addData.l_s_repair_text}</span><span>₹ ${fmtCur(addData.l_s_repair_value2)}</span></div>` : ""}

//       <div class="print-total"><span>Total</span><span>₹ ${fmtCur(responseData?.sales_total)}</span></div>
//     </div>

//     <div class="print-col">
//       <div class="print-section-title">Expense</div>

//       <div class="print-row"><span class="label">Exchange</span><span>₹ ${fmtCur(responseData?.exchange)}</span></div>
//       ${rowsHtml(exchangeData)}

//       <div class="print-row"><span class="label">G Pay</span><span>₹ ${fmtCur(responseData?.gpay)}</span></div>
//       ${gpayRowsHtml}

//       <div class="print-row"><span class="label">Expense</span><span>₹ ${fmtCur(responseData?.expense)}</span></div>
//       ${expenseRowsHtml}

//       <div class="print-row"><span class="label">Loan Closed List</span><span>₹ ${fmtCur(responseData?.loan_closed_list ?? loanData.reduce((s, l) => s + parseFloat(l.loan_amount || 0), 0))}</span></div>
//       ${loanRowsHtml}

//       <div class="print-row"><span class="label">Chit Closed List</span><span>₹ ${fmtCur(responseData?.chit_closed_list ?? chitData.reduce((s, c) => s + parseFloat(c.amount || 0), 0))}</span></div>
//       ${chitRowsHtml}

//       <div class="print-row"><span class="label">Amount Staff → Manager</span><span>₹ ${fmtCur(addData.amount_staff)}</span></div>
//       <div class="print-row"><span class="label">Amount in Cash</span><span>₹ ${fmtCur(addData.amount_in_cash)}</span></div>

//       <div class="print-total"><span>Total</span><span>₹ ${fmtCur(responseData?.expense_total)}</span></div>
//     </div>
//   </div>

// </body>
// </html>`;

//   w.document.open();
//   w.document.write(html);
//   w.document.close();

//   w.onload = () => {
//     w.focus();
//     w.print();
//   };
// };

//   const [addData, setAddData] = useState({
//     l_s_repair_text: "", l_s_repair_value1: "", l_s_repair_value2: "",
//     amount_in_cash: "", amount_staff: "", date, created_by: "", created_date: "",
//   });

//   const fetchExchangeData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/sales.php`, { params: { date } });
//       const allSales = hasManagerFilter
//         ? (response.data?.data || []).filter((s) => s.manager === managerFilter)
//         : (response.data?.data || []);
//       const exchangeRows = [];
//       allSales.forEach((sale) => {
//         (sale.item_list || []).forEach((item) => {
//           if ((item.action_type || "").trim().toLowerCase() === "old sales") {
//             exchangeRows.push({
//               sale_id: sale.sales_no,
//               customer_name: sale.customer_name || sale.customer_data?.customer_name || "-",
//               item_name: item.item_name_english || item.item || "-",
//               weight: item.weight || "-",
//               rate: item.rate || "-",
//               amount: item.amount || 0,
//             });
//           }
//         });
//       });
//       setExchangeData(exchangeRows);
//     } catch (error) {
//       console.error("Error fetching exchange data:", error.message);
//       setExchangeData([]);
//     }
//   };

//   // ── Retailer Balance — retailer_details.php aggregates `close` per date.
//   // NOTE: this endpoint expects the date as dd-mm-yyyy, unlike every other endpoint here. ──
//   const fetchRetailerBalanceData = async () => {
//     try {
//       const [y, m, d] = date.split("-");
//       const ddmmyyyy = `${d}-${m}-${y}`;
//       const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`, { params: { date: ddmmyyyy } });
//       const all = response.data?.data || [];
//       const rows = all.map((r) => ({
//         sale_id: r.retailer_id,
//         customer_name: r.supplier_details?.name || "-",
//         item_name: "-",
//         weight: "-",
//         rate: "-",
//         amount: r.close,
//       }));
//       setRetailerBalanceData(rows);
//     } catch (error) {
//       console.error("Error fetching retailer balance data:", error.message);
//       setRetailerBalanceData([]);
//     }
//   };

//   // ── Order Advance / Order Complete — both come from orders.php, split by
//   // order_date (advance) vs confirmed delivery_date (complete), matching the
//   // same logic sales_vs_expense.php uses to compute the summary totals above. ──
//   const fetchOrdersData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/orders.php`, { params: { date } });
//       const allOrders = response.data?.data || [];
//       const all = hasManagerFilter
//         ? allOrders.filter((o) => o.manager_name === managerFilter)
//         : allOrders;

//       const advanceRows = all
//         .filter((o) => (o.order_date || "").substring(0, 10) === date)
//         .map((o) => ({
//           sale_id: o.order_no,
//           customer_name: o.customer_info?.name || "-",
//           item_name: "-",
//           weight: "-",
//           rate: "-",
//           amount: o.advance_amount,
//         }));

//       const completeRows = all
//         .filter((o) => (o.delivery_status || "").toLowerCase() === "confirm" && (o.delivery_date || "").substring(0, 10) === date)
//         .map((o) => ({
//           sale_id: o.order_no,
//           customer_name: o.customer_info?.name || "-",
//           item_name: "-",
//           weight: "-",
//           rate: "-",
//           amount: o.paid,
//         }));

//       setOrderAdvanceData(advanceRows);
//       setOrderCompleteData(completeRows);
//     } catch (error) {
//       console.error("Error fetching orders data:", error.message);
//       setOrderAdvanceData([]);
//       setOrderCompleteData([]);
//     }
//   };

//   useEffect(() => {
//     fetchData(); fetchSalesData(); fetchExpenseData();
//     fetchGpayData(); fetchLoanData(); fetchChitData(); fetchExchangeData();
//     fetchRetailerBalanceData(); fetchOrdersData();
//   }, [date]);

//   useEffect(() => {
//     const totalAmount = payments.reduce((sum, p) => sum + parseFloat(p.paid_amount || 0), 0).toFixed(2);
//     setAddData((prev) => ({ ...prev, amount_staff: totalAmount }));
//   }, [payments]);

//   const fetchData = async () => {
//     try {
//       const params = hasManagerFilter ? { date, manager: managerFilter } : { date };
//       const response = await axios.get(`${ApiUrl}/Api/sales_vs_expense.php`, { params });
//       if (Array.isArray(response.data?.managers)) {
//         setAllManagers(response.data.managers);
//       }
//       if (response.data.status && response.data.data && response.data.data.length > 0) {
//         const record =
//           response.data.data.find((item) => item.date === date) ||
//           response.data.data.find((item) => {
//             const normalized = item.date?.includes("T") ? item.date.split("T")[0] : item.date?.substring(0, 10);
//             return normalized === date;
//           }) || response.data.data[0];
//         if (record) {
//           setResponseData(record);
//           setPayments(record.payment_data || []);
//           setAddData({
//             l_s_repair_text: record.l_s_repair_text || "",
//             l_s_repair_value1: record.l_s_repair_value1 || "",
//             l_s_repair_value2: record.l_s_repair_value2 || "",
//             amount_in_cash: record.amount_in_cash || "",
//             amount_staff: record.amount_staff || "",
//             date: record.date,
//             created_by: record.created_by || "",
//             created_date: record.created_date || "",
//           });
//         } else { resetForm(); }
//       } else { resetForm(); }
//     } catch (error) { console.error("Error fetching data:", error.message); resetForm(); }
//   };

//   const resetForm = () => {
//     setResponseData(null); setPayments([]);
//     setAddData({ l_s_repair_text: "", l_s_repair_value1: "", l_s_repair_value2: "", amount_in_cash: "", amount_staff: "", date, created_by: "", created_date: "" });
//   };

//   const fetchSalesData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/sales.php`, { params: { date } });
//       const allSales = response.data?.data || [];
//       setResponseSalesData(hasManagerFilter ? allSales.filter((s) => s.manager === managerFilter) : allSales);
//     } catch (error) { console.error("Error fetching sales data:", error.message); setResponseSalesData([]); }
//   };

//   const fetchExpenseData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/expense.php`, { params: { date } });
//       const all = response.data?.data || [];
//       setExpenseData(all.filter((e) => (e.date || "").substring(0, 10) === date));
//     } catch (error) { console.error("Error fetching expense data:", error.message); setExpenseData([]); }
//   };

//   const fetchGpayData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/sales.php`, { params: { date } });
//       const allSales = hasManagerFilter
//         ? (response.data?.data || []).filter((s) => s.manager === managerFilter)
//         : (response.data?.data || []);
//       const gpayRows = [];
//       allSales.forEach((sale) => {
//         const cName = sale.customer_name || sale.customer_data?.customer_name || "-";
//         (sale.payment_history || []).forEach((ph) => {
//           if (ph.payment_type && ph.payment_type.toLowerCase() !== "cash") {
//             gpayRows.push({ sale_id: sale.sales_no, customer_name: cName, value: ph.amount, txn_date: ph.date || sale.sales_date, pay_type: ph.payment_type });
//           }
//         });
//       });
//       setGpayData(gpayRows);
//     } catch (error) { console.error("Error fetching gpay data:", error.message); setGpayData([]); }
//   };

//   const fetchLoanData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/loan.php`);
//       const all = response.data?.data || [];
//       setLoanData(all.filter((l) => (l.loan_status || "").toLowerCase() === "close" && (l.loan_close_date || "").substring(0, 10) === date));
//     } catch (error) { console.error("Error fetching loan data:", error.message); setLoanData([]); }
//   };

//   const fetchChitData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/chit_list.php`);
//       const all = response.data?.data || [];
//       setChitData(all.filter((c) => (c.status || "").toLowerCase() === "close" && (c.close_date || "").substring(0, 10) === date));
//     } catch (error) { console.error("Error fetching chit data:", error.message); setChitData([]); }
//   };

//   const handleSubmitData = async () => {
//     try {
//       const { l_s_repair_text, l_s_repair_value1, l_s_repair_value2, amount_in_cash } = addData;
//       if (!l_s_repair_text && !l_s_repair_value1 && !l_s_repair_value2 && !amount_in_cash) {
//         alert("Please fill at least one field."); return;
//       }
//       const formData = {
//         l_s_repair_text: l_s_repair_text || "", l_s_repair_value1: l_s_repair_value1 || "",
//         l_s_repair_value2: l_s_repair_value2 || "", amount_in_cash: amount_in_cash || "",
//         amount_staff: addData.amount_staff || "", date,
//         created_by: addData.created_by || "", created_date: addData.created_date || new Date().toISOString(),
//         updated_by: "", updated_date: new Date().toISOString(),
//       };
//       let response;
//       if (!responseData) {
//         response = await axios.post(`${ApiUrl}/Api/sales_collection.php`, formData, { headers: { "Content-Type": "application/json" } });
//       } else {
//         response = await axios.put(`${ApiUrl}/Api/sales_collection.php?date=${date}`, formData, { headers: { "Content-Type": "application/json" } });
//       }
//       navigate("/sales-vs-expense");
//       if (response.data.status) { alert(!responseData ? "Data created successfully!" : "Data updated successfully!"); fetchData(); }
//       else { throw new Error(response.data.message || "Failed to save data"); }
//     } catch (error) { console.error("Error saving data:", error.message); alert(`Error saving data: ${error.message}`); }
//   };

//   const handlePaymentSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (!paymentManager) {
//         alert("Please select which manager is giving this amount"); return;
//       }
//       if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
//         alert("Please select a payment type and enter a valid amount"); return;
//       }
//       const paymentData = {
//         date, pay_type: paymentType, paid_amount: parseFloat(paymentAmount).toFixed(2), manager: paymentManager,
//         created_by: "", created_date: new Date().toISOString(), updated_by: "", updated_date: "",
//       };
//       const response = await axios.post(`${ApiUrl}/Api/sales_vs_expense_payment.php`, paymentData, { headers: { "Content-Type": "application/json" } });
//       if (response.data.status) {
//         alert("Payment submitted successfully!"); setPaymentAmount(""); setPaymentType(""); setPaymentManager(""); closePaymentModal(); fetchData();
//       } else { throw new Error(response.data.message || "Failed to submit payment"); }
//     } catch (error) { console.error("Error submitting payment:", error.message); alert(`Error submitting payment: ${error.message}`); }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const d = new Date(dateString);
//       if (isNaN(d.getTime())) return dateString;
//       return `${String(d.getDate()).padStart(2,"0")}-${String(d.getMonth()+1).padStart(2,"0")}-${d.getFullYear()}`;
//     } catch { return dateString; }
//   };

//   const formatCurrency = (value) => {
//     if (value === null || value === undefined || isNaN(value)) return "0";
//     return Number(value).toLocaleString("en-IN");
//   };

//   const customerName = (sale) => sale.customer_name || sale.customer_data?.customer_name || "-";

//   // ── Generic helper to pull line-item rows out of sales data by action_type,
//   // formatted consistently as: S.No, Sale ID, Customer, Item, Weight, Rate, Amount ──
//   const getItemsByActionType = (typeLabel) => {
//     const rows = [];
//     responseSalesData.forEach((sale) => {
//       (sale.item_list || []).forEach((item) => {
//         if ((item.action_type || "").trim().toLowerCase() === typeLabel.toLowerCase()) {
//           rows.push({
//             sale_id: sale.sales_no,
//             customer_name: customerName(sale),
//             item_name: item.item_name_english || item.item || "-",
//             weight: item.weight || "-",
//             rate: item.rate || "-",
//             amount: parseFloat(sale.net_total) || 0,
//           });
//         }
//       });
//     });
//     return rows;
//   };

//   // ── Sales / PO Sales / Old Sales are genuine sales_items.action_type rows,
//   // so they stay driven off the item-level helper. ──
//   const salesData    = getItemsByActionType("new");
//   const poSalesData  = getItemsByActionType("po-sale");
//   const oldSalesData = getItemsByActionType("old sales");

//   // ── Sales Balance is NOT an action_type — it's the row-level `balance`
//   // field on each sale itself (same field sales_vs_expense.php sums for
//   // the `sales_balance` total shown above this table). No extra API call
//   // needed since responseSalesData already carries every sales column. ──
//   const salesBalanceData = responseSalesData
//     .filter((sale) => parseFloat(sale.balance) > 0)
//     .map((sale) => ({
//       sale_id: sale.sales_no,
//       customer_name: customerName(sale),
//       item_name: "-",
//       weight: "-",
//       rate: "-",
//       amount: sale.balance,
//     }));

//   // retailerBalanceData, orderAdvanceData, orderCompleteData come from state
//   // (populated by fetchRetailerBalanceData / fetchOrdersData above).

//   const ToggleBtn = ({ show, onClick }) => (
//     <button className="btn btn-sm btn-success" onClick={onClick}>
//       <i className={`fa-solid fa-${show ? "minus" : "plus"}`}></i>
//     </button>
//   );

//   const NoData = ({ cols, msg }) => (
//     <tr><td colSpan={cols} className="text-center text-muted">{msg}</td></tr>
//   );

//   // ── Reusable item-level table renderer: S.No, Sale ID, Customer Name, Item Name, Weight, Rate, Amount ──
//   const ItemTable = ({ data, emptyMsg }) => (
//     <div className="mt-2 table-responsive">
//       <table className="table table-bordered table-sm">
//         <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Item Name</th><th>Weight</th><th>Rate</th><th>Amount</th></tr></thead>
//         <tbody>{data.length > 0 ? data.map((e,i) => (
//           <tr key={i}><td>{i+1}</td><td>{e.sale_id||"-"}</td><td>{e.customer_name||"-"}</td><td>{e.item_name||"-"}</td><td>{e.weight||"-"}</td><td>₹ {formatCurrency(e.rate)}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
//         )) : <NoData cols={7} msg={emptyMsg} />}</tbody>
//       </table>
//     </div>
//   );

//   const PrintItemTable = ({ data }) => (
//     data.length > 0 && (
//       <table><thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Item</th><th>Wt</th><th>Rate</th><th>Amt</th></tr></thead>
//       <tbody>{data.map((e,i)=>(
//         <tr key={i}><td>{i+1}</td><td>{e.sale_id}</td><td>{e.customer_name}</td><td>{e.item_name}</td><td>{e.weight}</td><td>₹{formatCurrency(e.rate)}</td><td>₹{formatCurrency(e.amount)}</td></tr>
//       ))}</tbody></table>
//     )
//   );

//   return (
//     <div className="container-fluid pb-5">
//       <div className="card shadow-sm ">
//         <div className="card-body">
//           <div className="container-fluid">
//             <div className="card rounded-3 p-3 print-area" style={{ backgroundColor: "#D5F1F1" }}>

//               {/* ── PRINT COMPANY HEADER ── */}
//               <div className="print-company-header">
//                 <img
//                   src={companyLogo}
//                   alt="Logo"
//                   width="100" height="55"
//                   className="co-logo"
//                   onError={(e) => { e.target.style.display = "none"; }}
//                 />
//                 <div className="co-details">
//                   <h2>TIRUPUR JEWELLERY</h2>
//                   <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
//                   <p>Ph: 04272233807</p>
//                 </div>
//                 <div className="co-title">
//                   TXN OVERVIEW
//                   {hasManagerFilter && (
//                     <span className="co-manager">Manager: {managerName}</span>
//                   )}
//                 </div>
//               </div>

//               {/* ── PRINT DATE HEADER ── */}
//               <div className="print-header">
//                 Transaction Overview — {formatDate(date)}
//               </div>

//               {/* ── SCREEN TITLE (manager badge in the top-right corner) ── */}
//               <div className="d-flex justify-content-between align-items-center mb-3 no-print">
//                 <div style={{ width: "160px" }}></div>
//                 <h5 className="text-center text-black border-0 mb-0 flex-grow-1">
//                   Transaction Overview — {formatDate(date)}
//                 </h5>
//                 <div style={{ width: "160px" }} className="text-end">
//                   {hasManagerFilter && (
//                     <span className="badge bg-primary px-3 py-2">
//                       Manager: {managerName}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* ── PRINT LAYOUT ── */}
//               <div className="print-columns">

//                 {/* LEFT: Sales */}
//                 <div className="print-col">
//                   <div className="print-section-title">Sales</div>

//                   <div className="print-row"><span className="label">Sales</span><span>₹ {formatCurrency(responseData?.sales)}</span></div>
//                   <PrintItemTable data={salesData} />

//                   <div className="print-row"><span className="label">PO Sales</span><span>₹ {formatCurrency(responseData?.po_sales)}</span></div>
//                   <PrintItemTable data={poSalesData} />

//                   <div className="print-row"><span className="label">Old Sales</span><span>₹ {formatCurrency(responseData?.old_sales)}</span></div>
//                   <PrintItemTable data={oldSalesData} />

//                   {/* ── Sales Balance ── */}
//                   <div className="print-row"><span className="label">Sales Balance</span><span>₹ {formatCurrency(responseData?.sales_balance)}</span></div>
//                   <PrintItemTable data={salesBalanceData} />

//                   {/* ── Retailer Balance ── */}
//                   <div className="print-row"><span className="label">Retailer Balance</span><span>₹ {formatCurrency(responseData?.retailer_balance)}</span></div>
//                   <PrintItemTable data={retailerBalanceData} />

//                   {/* ── Order Advance ── */}
//                   <div className="print-row"><span className="label">Order Advance</span><span>₹ {formatCurrency(responseData?.order_advance)}</span></div>
//                   <PrintItemTable data={orderAdvanceData} />

//                   {/* ── Order Complete ── */}
//                   <div className="print-row"><span className="label">Order Complete</span><span>₹ {formatCurrency(responseData?.order_complete)}</span></div>
//                   <PrintItemTable data={orderCompleteData} />

//                   {addData.l_s_repair_value1 && <div className="print-row"><span className="label">L.S. Repair</span><span>₹ {formatCurrency(addData.l_s_repair_value1)}</span></div>}
//                   {addData.l_s_repair_text && addData.l_s_repair_value2 && <div className="print-row"><span className="label">{addData.l_s_repair_text}</span><span>₹ {formatCurrency(addData.l_s_repair_value2)}</span></div>}
//                   <div className="print-total"><span>Total</span><span>₹ {formatCurrency(responseData?.sales_total)}</span></div>
//                 </div>

//                 {/* RIGHT: Expense */}
//                 <div className="print-col">
//                   <div className="print-section-title">Expense</div>

//                   <div className="print-row"><span className="label">Exchange</span><span>₹ {formatCurrency(responseData?.exchange)}</span></div>
//                   {exchangeData.length > 0 && (
//                     <table><thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Item</th><th>Wt</th><th>Rate</th><th>Amt</th></tr></thead>
//                     <tbody>{exchangeData.map((e,i)=>(
//                       <tr key={i}><td>{i+1}</td><td>{e.sale_id}</td><td>{e.customer_name}</td><td>{e.item_name}</td><td>{e.weight}</td><td>₹{formatCurrency(e.rate)}</td><td>₹{formatCurrency(e.amount)}</td></tr>
//                     ))}</tbody></table>
//                   )}

//                   <div className="print-row"><span className="label">G Pay</span><span>₹ {formatCurrency(responseData?.gpay)}</span></div>
//                   {gpayData.length > 0 && (
//                     <table><thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Type</th><th>Date</th><th>Value</th></tr></thead>
//                     <tbody>{gpayData.map((g,i)=>(
//                       <tr key={i}><td>{i+1}</td><td>{g.sale_id}</td><td>{g.customer_name}</td><td>{g.pay_type}</td><td>{formatDate(g.txn_date)}</td><td>₹{formatCurrency(g.value)}</td></tr>
//                     ))}</tbody></table>
//                   )}

//                   <div className="print-row"><span className="label">Expense</span><span>₹ {formatCurrency(responseData?.expense)}</span></div>
//                   {expenseData.length > 0 && (
//                     <table><thead><tr><th>S.No</th><th>Exp No</th><th>Type</th><th>Description</th><th>Date</th><th>Amount</th></tr></thead>
//                     <tbody>{expenseData.map((e,i)=>(
//                       <tr key={i}><td>{i+1}</td><td>{e.id}</td><td>{e.type}</td><td>{e.description}</td><td>{formatDate(e.date)}</td><td>₹{formatCurrency(e.amount)}</td></tr>
//                     ))}</tbody></table>
//                   )}

//                   <div className="print-row"><span className="label">Loan Closed List</span><span>₹ {formatCurrency(responseData?.loan_closed_list ?? loanData.reduce((s,l)=>s+parseFloat(l.loan_amount||0),0))}</span></div>
//                   {loanData.length > 0 && (
//                     <table><thead><tr><th>S.No</th><th>Loan ID</th><th>Customer</th><th>Category</th><th>Amount</th></tr></thead>
//                     <tbody>{loanData.map((l,i)=>(
//                       <tr key={i}><td>{i+1}</td><td>{l.loan_id}</td><td>{l.customer?.customer_name||"-"}</td><td>{l.loan_list?.[0]?.category||"-"}</td><td>₹{formatCurrency(l.loan_amount)}</td></tr>
//                     ))}</tbody></table>
//                   )}

//                   <div className="print-row"><span className="label">Chit Closed List</span><span>₹ {formatCurrency(responseData?.chit_closed_list ?? chitData.reduce((s,c)=>s+parseFloat(c.amount||0),0))}</span></div>
//                   {chitData.length > 0 && (
//                     <table><thead><tr><th>S.No</th><th>Chit ID</th><th>Customer</th><th>Duration</th><th>Amount</th></tr></thead>
//                     <tbody>{chitData.map((c,i)=>(
//                       <tr key={i}><td>{i+1}</td><td>{c.chit_id}</td><td>{c.name||"-"}</td><td>{c.duration}</td><td>₹{formatCurrency(c.amount)}</td></tr>
//                     ))}</tbody></table>
//                   )}

//                   <div className="print-row"><span className="label">Amount Staff → Manager</span><span>₹ {formatCurrency(addData.amount_staff)}</span></div>
//                   <div className="print-row"><span className="label">Amount in Cash</span><span>₹ {formatCurrency(addData.amount_in_cash)}</span></div>
//                   <div className="print-total"><span>Total</span><span>₹ {formatCurrency(responseData?.expense_total)}</span></div>
//                 </div>
//               </div>

//               {/* ── SCREEN LAYOUT ── */}
//               <div className="row no-print">

//                 {/* SALES SIDE */}
//                 <div className="col-lg-6">
//                   <div className="card p-4">
//                     <h6 className="text-primary mb-4">Sales</h6>

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Sales</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.sales)}</div>
//                         <ToggleBtn show={showSalesTable} onClick={() => setShowSalesTable(!showSalesTable)} />
//                       </div>
//                     </div>
//                     {showSalesTable && <ItemTable data={salesData} emptyMsg="No sales data available" />}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">PO Sales</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.po_sales)}</div>
//                         <ToggleBtn show={showPoSalesTable} onClick={() => setShowPoSalesTable(!showPoSalesTable)} />
//                       </div>
//                     </div>
//                     {showPoSalesTable && <ItemTable data={poSalesData} emptyMsg="No PO sales data available" />}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Old Sales</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.old_sales)}</div>
//                         <ToggleBtn show={showOldSalesTable} onClick={() => setShowOldSalesTable(!showOldSalesTable)} />
//                       </div>
//                     </div>
//                     {showOldSalesTable && <ItemTable data={oldSalesData} emptyMsg="No old sales data available" />}

//                     {/* ── Sales Balance ── */}
//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Sales Balance</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.sales_balance)}</div>
//                         <ToggleBtn show={showSalesBalanceTable} onClick={() => setShowSalesBalanceTable(!showSalesBalanceTable)} />
//                       </div>
//                     </div>
//                     {showSalesBalanceTable && <ItemTable data={salesBalanceData} emptyMsg="No sales balance data available" />}

//                     {/* ── Retailer Balance ── */}
//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Retailer Balance</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.retailer_balance)}</div>
//                         <ToggleBtn show={showRetailerBalanceTable} onClick={() => setShowRetailerBalanceTable(!showRetailerBalanceTable)} />
//                       </div>
//                     </div>
//                     {showRetailerBalanceTable && <ItemTable data={retailerBalanceData} emptyMsg="No retailer balance data available" />}

//                     {/* ── Order Advance ── */}
//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Order Advance</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.order_advance)}</div>
//                         <ToggleBtn show={showOrderAdvanceTable} onClick={() => setShowOrderAdvanceTable(!showOrderAdvanceTable)} />
//                       </div>
//                     </div>
//                     {showOrderAdvanceTable && <ItemTable data={orderAdvanceData} emptyMsg="No order advance data available" />}

//                     {/* ── Order Complete ── */}
//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Order Complete</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.order_complete)}</div>
//                         <ToggleBtn show={showOrderCompleteTable} onClick={() => setShowOrderCompleteTable(!showOrderCompleteTable)} />
//                       </div>
//                     </div>
//                     {showOrderCompleteTable && <ItemTable data={orderCompleteData} emptyMsg="No order complete data available" />}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">L.S. Repair</span>
//                       <input type="text" className="form-control" placeholder="Enter Value" value={addData.l_s_repair_value1} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, l_s_repair_value1: e.target.value })} />
//                     </div>
//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <input type="text" className="form-control" placeholder="Enter Text" value={addData.l_s_repair_text} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, l_s_repair_text: e.target.value })} />
//                       <input type="text" className="form-control" placeholder="Enter Value" value={addData.l_s_repair_value2} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, l_s_repair_value2: e.target.value })} />
//                     </div>

//                     <div className="mt-3 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Total</span>
//                       <div className="border rounded px-3 py-1 text-end" style={{ width: "180px" }}>₹ {formatCurrency(responseData?.sales_total)}</div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* EXPENSE SIDE */}
//                 <div className="col-lg-6">
//                   <div className="card h-100 p-3">
//                     <h6 className="text-primary mb-4">Expense</h6>

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Exchange</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.exchange)}</div>
//                         <ToggleBtn show={showExchangeTable} onClick={() => setShowExchangeTable(!showExchangeTable)} />
//                       </div>
//                     </div>
//                     {showExchangeTable && (
//                       <div className="mt-2 table-responsive">
//                         <table className="table table-bordered table-sm">
//                           <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Item Name</th><th>Weight</th><th>Rate</th><th>Amount</th></tr></thead>
//                           <tbody>{exchangeData.length > 0 ? exchangeData.map((e,i) => (
//                             <tr key={i}><td>{i+1}</td><td>{e.sale_id||"-"}</td><td>{e.customer_name||"-"}</td><td>{e.item_name||"-"}</td><td>{e.weight||"-"}</td><td>₹ {formatCurrency(e.rate)}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
//                           )) : <NoData cols={7} msg="No exchange data available" />}</tbody>
//                         </table>
//                       </div>
//                     )}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">G Pay</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.gpay)}</div>
//                         <ToggleBtn show={showGpayTable} onClick={() => setShowGpayTable(!showGpayTable)} />
//                       </div>
//                     </div>
//                     {showGpayTable && (
//                       <div className="mt-2 table-responsive">
//                         <table className="table table-bordered table-sm">
//                           <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Pay Type</th><th>Txn Date</th><th>Value</th></tr></thead>
//                           <tbody>{gpayData.length > 0 ? gpayData.map((g,i) => (
//                             <tr key={i}><td>{i+1}</td><td>{g.sale_id||"-"}</td><td>{g.customer_name||"-"}</td><td>{g.pay_type||"-"}</td><td>{formatDate(g.txn_date)||"-"}</td><td>₹ {formatCurrency(g.value)}</td></tr>
//                           )) : <NoData cols={6} msg="No G Pay data available" />}</tbody>
//                         </table>
//                       </div>
//                     )}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Expense</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.expense)}</div>
//                         <ToggleBtn show={showExpenseTable} onClick={() => setShowExpenseTable(!showExpenseTable)} />
//                       </div>
//                     </div>
//                     {showExpenseTable && (
//                       <div className="mt-2 table-responsive">
//                         <table className="table table-bordered table-sm">
//                           <thead className="table-light"><tr><th>S.No</th><th>Expense No</th><th>Type</th><th>Description</th><th>Exp Date</th><th>Amount</th></tr></thead>
//                           <tbody>{expenseData.length > 0 ? expenseData.map((e,i) => (
//                             <tr key={i}><td>{i+1}</td><td>{e.id||"-"}</td><td>{e.type||"-"}</td><td>{e.description||"-"}</td><td>{formatDate(e.date)||"-"}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
//                           )) : <NoData cols={6} msg="No expense data available" />}</tbody>
//                         </table>
//                       </div>
//                     )}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Loan Closed List</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.loan_closed_list ?? loanData.reduce((s,l)=>s+parseFloat(l.loan_amount||0),0))}</div>
//                         <ToggleBtn show={showLoanTable} onClick={() => setShowLoanTable(!showLoanTable)} />
//                       </div>
//                     </div>
//                     {showLoanTable && (
//                       <div className="mt-2 table-responsive">
//                         <table className="table table-bordered table-sm">
//                           <thead className="table-light"><tr><th>S.No</th><th>Loan ID</th><th>Customer Name</th><th>Category</th><th>Loan Amount</th></tr></thead>
//                           <tbody>{loanData.length > 0 ? loanData.map((l,i) => (
//                             <tr key={i}><td>{i+1}</td><td>{l.loan_id||"-"}</td><td>{l.customer?.customer_name||"-"}</td><td>{l.loan_list?.[0]?.category||"-"}</td><td>₹ {formatCurrency(l.loan_amount)}</td></tr>
//                           )) : <NoData cols={5} msg="No loan data available" />}</tbody>
//                         </table>
//                       </div>
//                     )}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Chit Closed List</span>
//                       <div className="d-flex gap-2">
//                         <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.chit_closed_list ?? chitData.reduce((s,c)=>s+parseFloat(c.amount||0),0))}</div>
//                         <ToggleBtn show={showChitTable} onClick={() => setShowChitTable(!showChitTable)} />
//                       </div>
//                     </div>
//                     {showChitTable && (
//                       <div className="mt-2 table-responsive">
//                         <table className="table table-bordered table-sm">
//                           <thead className="table-light"><tr><th>S.No</th><th>Chit ID</th><th>Customer Name</th><th>Duration</th><th>Amount</th></tr></thead>
//                           <tbody>{chitData.length > 0 ? chitData.map((c,i) => (
//                             <tr key={i}><td>{i+1}</td><td>{c.chit_id||"-"}</td><td>{c.name||"-"}</td><td>{c.duration||"-"}</td><td>₹ {formatCurrency(c.amount)}</td></tr>
//                           )) : <NoData cols={5} msg="No chit data available" />}</tbody>
//                         </table>
//                       </div>
//                     )}

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <div><span className="fw-bold">Amount</span><br /><span className="small">Manager <i className="fa-solid fa-arrow-right"></i> Admin</span></div>
//                       <div className="d-flex align-items-center" style={{ width: "250px" }}>
//                         <input type="text" className="form-control mt-3" placeholder="Amount" value={addData.amount_staff} disabled />
//                         <button className="btn btn-success ms-2" onClick={openPaymentModal}>+</button>
//                         <button className="btn btn-light ms-1 border" onClick={openInfoModal}><i className="bi bi-info-circle"></i></button>
//                       </div>
//                     </div>

//                     <div className="mb-1 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Amount in Cash</span>
//                       <input type="text" className="form-control" placeholder="Enter Amount" value={addData.amount_in_cash} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, amount_in_cash: e.target.value })} />
//                     </div>

//                     <div className="mt-3 d-flex justify-content-between align-items-center">
//                       <span className="fw-bold">Total</span>
//                       <div className="border rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.expense_total)}</div>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="row mt-4 no-print">
//                       <div className="col-12 d-flex justify-content-end gap-2">
//                         <button className="btn btn-sm btn-secondary" onClick={() => navigate("/sales-vs-expense")}>
//                           <i className="fa-solid fa-arrow-left me-1"></i> Back
//                         </button>
//                         <button className="btn btn-sm btn-primary" onClick={handleSubmitData}>
//                           <i className="fa-solid fa-floppy-disk me-1"></i>
//                           {responseData ? "Update" : "Save"}
//                         </button>
//                         <button className="btn btn-sm btn-info text-white" onClick={handlePrint}>
//                           <i className="fa-solid fa-print me-1"></i> Print
//                         </button>
//                       </div>
//                     </div>

//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Add Payment Modal */}
//           <div className={`modal fade ${paymentModal ? "show" : ""}`} style={{ display: paymentModal ? "block" : "none" }} tabIndex="-1" aria-hidden={!paymentModal}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h6 className="modal-title text-primary">Add Payment</h6>
//                   <button type="button" className="btn-close" style={{ fontSize: "10px" }} onClick={closePaymentModal}></button>
//                 </div>
//                 <div className="modal-body">
//                   <form onSubmit={handlePaymentSubmit}>
//                     <div className="row">
//                       <div className="col-lg-4">
//                         <div className="mb-3">
//                           <label>Manager</label>
//                           <select className="form-select" value={paymentManager} onChange={(e) => setPaymentManager(e.target.value)}>
//                             <option value="">Select Manager</option>
//                             {allManagers.map((m) => (
//                               <option key={m} value={m}>{m}</option>
//                             ))}
//                           </select>
//                         </div>
//                       </div>
//                       <div className="col-lg-4">
//                         <div className="mb-3">
//                           <label>Pay Type</label>
//                           <select className="form-select" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
//                             <option value="">Select Paytype</option>
//                             <option value="cash">Cash</option>
//                             <option value="gpay">Gpay</option>
//                             <option value="phonepe">Phonepe</option>
//                             <option value="paytm">Paytm</option>
//                             <option value="credit">Credit</option>
//                             <option value="debit">Debit</option>
//                           </select>
//                         </div>
//                       </div>
//                       <div className="col-lg-4">
//                         <div className="mb-3">
//                           <label>Enter Amount</label>
//                           <input type="number" className="form-control" placeholder="Enter Amount" value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)} />
//                         </div>
//                       </div>
//                       <div className="col-lg-4">
//                         <button type="submit" className="btn btn-primary btn-sm mt-4">Submit</button>
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Payment History Modal */}
//           <div className={`modal fade ${infoModal ? "show" : ""}`} style={{ display: infoModal ? "block" : "none" }} tabIndex="-1" aria-hidden={!infoModal}>
//             <div className="modal-dialog modal-dialog-centered modal-lg">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h6 className="modal-title text-primary">Payment History - {formatDate(date)}</h6>
//                   <button type="button" className="btn-close" style={{ fontSize: "10px" }} onClick={closeInfoModal}></button>
//                 </div>
//                 <div className="modal-body">
//                   <div className="card" style={{ borderRadius: "15px", backgroundColor: "#5c9dff", color: "white" }}>
//                     <div className="card-body">
//                       <div className="table-responsive">
//                         <table className="table text-white">
//                           <thead><tr><th>S.No</th><th>Date</th><th>Manager</th><th>Pay Type</th><th>Paid Amount</th></tr></thead>
//                           <tbody>
//                             {payments.length > 0 ? payments.map((payment, index) => (
//                               <tr key={payment.id || index}><td>{index+1}</td><td>{formatDate(payment.date)}</td><td>{payment.manager || "-"}</td><td>{payment.pay_type}</td><td>₹ {formatCurrency(payment.paid_amount)}</td></tr>
//                             )) : <tr><td colSpan="5" className="text-center">No payment history available for {formatDate(date)}</td></tr>}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {(paymentModal || infoModal) && (
//             <div className="modal-backdrop fade show" onClick={() => { closePaymentModal(); closeInfoModal(); }}></div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SalesVsExpense;


import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import companyLogo,{} from "../../../src/assets/images/Final logo.png";
import "../../../src/assets/css/salesvsexpense.css";

function SalesVsExpense() {
  const navigate = useNavigate();
  const { date } = useParams();
  const companyLogoUrl = companyLogo;
  const location = useLocation();

  const [paymentModal, setPaymentModal]   = useState(false);
  const [infoModal, setInfoModal]         = useState(false);
  const [responseData, setResponseData]   = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentType, setPaymentType]     = useState("");
  const [paymentManager, setPaymentManager] = useState(""); // which manager is handing this amount to Admin
  const [allManagers, setAllManagers]     = useState([]);
  const [payments, setPayments]           = useState([]);
  const [responseSalesData, setResponseSalesData] = useState([]);
  const [exchangeData, setExchangeData]   = useState([]);

  const [expenseData, setExpenseData] = useState([]);
  const [gpayData, setGpayData]       = useState([]);
  const [loanData, setLoanData]       = useState([]);
  const [chitData, setChitData]       = useState([]);

  // ── real data sources for the four sections that are NOT sales_items.action_type rows ──
  const [retailerBalanceData, setRetailerBalanceData] = useState([]);
  const [orderAdvanceData,    setOrderAdvanceData]    = useState([]);
  const [orderCompleteData,   setOrderCompleteData]   = useState([]);

  const [showSalesTable,    setShowSalesTable]    = useState(false);
  const [showPoSalesTable,  setShowPoSalesTable]  = useState(false);
  const [showOldSalesTable, setShowOldSalesTable] = useState(false);
  const [showExpenseTable,  setShowExpenseTable]  = useState(false);
  const [showGpayTable,     setShowGpayTable]     = useState(false);
  const [showLoanTable,     setShowLoanTable]     = useState(false);
  const [showChitTable,     setShowChitTable]     = useState(false);
  const [showExchangeTable, setShowExchangeTable] = useState(false);
  const [showRefundTable, setShowRefundTable] = useState(false);

  // ── toggle state for Sales Balance / Retailer Balance / Order Advance / Order Complete ──
  const [showSalesBalanceTable,    setShowSalesBalanceTable]    = useState(false);
  const [showRetailerBalanceTable, setShowRetailerBalanceTable] = useState(false);
  const [showOrderAdvanceTable,    setShowOrderAdvanceTable]    = useState(false);
  const [showOrderCompleteTable,   setShowOrderCompleteTable]   = useState(false);

  const openPaymentModal  = () => setPaymentModal(true);
  const closePaymentModal = () => { setPaymentModal(false); setPaymentManager(""); setPaymentType(""); setPaymentAmount(""); };
  const openInfoModal     = () => setInfoModal(true);
  const closeInfoModal    = () => setInfoModal(false);

  // ── Manager filter. Comes from the list page (router state or ?manager=
  // query param) whenever the user filtered the list by a manager before
  // clicking Edit. Known immediately, before responseData loads, so it can
  // be used right away to scope the data fetches below. ──
  const queryManager = new URLSearchParams(location.search).get("manager");
  const managerFilter = location.state?.manager || queryManager || "";
  const hasManagerFilter = Boolean(managerFilter);

  // Manager name for the top-right badge — only ever shown when the page was
  // opened via a manager filter. Prefer the value that comes straight off the
  // record itself (sales_vs_expense.php echoes back the filtered `manager`),
  // falling back to whatever was passed in from the list page.
  const managerName = responseData?.manager || managerFilter;

  // const handlePrint = () => {
  //   // The print layout (.print-columns) renders every section's data
  //   // unconditionally already, so it never depended on the on-screen
  //   // accordion toggles below — forcing them all open here only left
  //   // the screen view messed up after printing, without fixing print.
  //   window.print();
  // };


  const handlePrint = () => {
  const w = window.open("", "_blank", "width=1200,height=800");
  if (!w) {
    alert("Please allow popups for this site to print.");
    return;
  }

  const fmtCur = formatCurrency;
  const fmtDate = formatDate;

  const rowsHtml = (data) => {
    if (!data || data.length === 0) return "";
    return `
      <table>
        <thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Item</th><th>Wt</th><th>Rate</th><th>Amt</th></tr></thead>
        <tbody>
          ${data.map((e, i) => `
            <tr>
              <td>${i + 1}</td>
              <td>${e.sale_id ?? "-"}</td>
              <td>${e.customer_name ?? "-"}</td>
              <td>${e.item_name ?? "-"}</td>
              <td>${e.weight ?? "-"}</td>
              <td>₹${fmtCur(e.rate)}</td>
              <td>₹${fmtCur(e.amount)}</td>
            </tr>`).join("")}
        </tbody>
      </table>`;
  };

  const gpayRowsHtml = gpayData.length === 0 ? "" : `
    <table>
      <thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Type</th><th>Date</th><th>Value</th></tr></thead>
      <tbody>
        ${gpayData.map((g, i) => `
          <tr>
            <td>${i + 1}</td><td>${g.sale_id}</td><td>${g.customer_name}</td>
            <td>${g.pay_type}</td><td>${fmtDate(g.txn_date)}</td><td>₹${fmtCur(g.value)}</td>
          </tr>`).join("")}
      </tbody>
    </table>`;

  const expenseRowsHtml = expenseData.length === 0 ? "" : `
    <table>
      <thead><tr><th>S.No</th><th>Exp No</th><th>Type</th><th>Description</th><th>Date</th><th>Amount</th></tr></thead>
      <tbody>
        ${expenseData.map((e, i) => `
          <tr>
            <td>${i + 1}</td><td>${e.id}</td><td>${e.type}</td>
            <td>${e.description}</td><td>${fmtDate(e.date)}</td><td>₹${fmtCur(e.amount)}</td>
          </tr>`).join("")}
      </tbody>
    </table>`;

  const loanRowsHtml = loanData.length === 0 ? "" : `
    <table>
      <thead><tr><th>S.No</th><th>Loan ID</th><th>Customer</th><th>Category</th><th>Amount</th></tr></thead>
      <tbody>
        ${loanData.map((l, i) => `
          <tr>
            <td>${i + 1}</td><td>${l.loan_id}</td><td>${l.customer?.customer_name ?? "-"}</td>
            <td>${l.loan_list?.[0]?.category ?? "-"}</td><td>₹${fmtCur(l.loan_amount)}</td>
          </tr>`).join("")}
      </tbody>
    </table>`;

  const chitRowsHtml = chitData.length === 0 ? "" : `
    <table>
      <thead><tr><th>S.No</th><th>Chit ID</th><th>Customer</th><th>Duration</th><th>Amount</th></tr></thead>
      <tbody>
        ${chitData.map((c, i) => `
          <tr>
            <td>${i + 1}</td><td>${c.chit_id}</td><td>${c.name ?? "-"}</td>
            <td>${c.duration}</td><td>₹${fmtCur(c.amount)}</td>
          </tr>`).join("")}
      </tbody>
    </table>`;

  const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>Transaction Overview - ${fmtDate(date)}</title>
<style>
  @page { size: A5 landscape; margin: 8mm; }
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; color: #000; }

  .co-header {
    display: flex; justify-content: space-between; align-items: center;
    border-bottom: 2px solid #000; padding-bottom: 5px; margin-bottom: 5px;
  }
  .co-logo { width: 90px; height: 55px; object-fit: contain; }
  .co-details { flex: 1; text-align: center; }
  .co-details h2 { margin: 0; font-size: 16px; }
  .co-details p { margin: 2px 0; font-size: 10px; }
  .co-title { font-size: 13px; font-weight: bold; text-align: right; }
  .co-manager { display: block; margin-top: 3px; font-size: 10px; }

  .print-header {
    text-align: center; font-weight: bold;
    border-top: 1px solid #000; border-bottom: 1px solid #000;
    padding: 4px; margin-bottom: 8px; font-size: 13px;
  }

  .print-columns { display: table; width: 100%; table-layout: fixed; border-spacing: 8px 0; }
  .print-col { display: table-cell; width: 50%; vertical-align: top; border: 1px solid #666; padding: 6px; }

  .print-section-title {
    color: #0d6efd; font-size: 12px; font-weight: bold;
    border-bottom: 1px solid #0d6efd; margin-bottom: 5px; padding-bottom: 3px;
  }

  .print-row {
    display: flex; justify-content: space-between;
    border-bottom: 1px dotted #bbb; padding: 3px 0; font-size: 10px;
  }
  .print-row .label { font-weight: bold; }

  .print-total {
    display: flex; justify-content: space-between;
    border-top: 2px solid #000; margin-top: 5px; padding-top: 5px;
    font-weight: bold; font-size: 11px;
  }

  table { width: 100%; border-collapse: collapse; font-size: 9px; margin: 4px 0 8px; table-layout: fixed; }
  table th, table td { border: 1px solid #999; padding: 2px 3px; overflow: hidden; word-break: break-word; }
  table th:last-child, table td:last-child { width: 18%; white-space: nowrap; text-align: right; }
  table th:nth-child(1), table td:nth-child(1) { width: 6%; }
  table th:nth-child(2), table td:nth-child(2) { width: 14%; }
  thead { display: table-header-group; }
  tr { page-break-inside: avoid; }
</style>
</head>
<body>

  <div class="co-header">
    <img class="co-logo" src="${window.location.origin}${companyLogoUrl}" onerror="this.style.display='none'" />
    <div class="co-details">
      <h2>TIRUPUR JEWELLERY</h2>
      <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
      <p>Ph: 04272233807</p>
    </div>
    <div class="co-title">
      TXN OVERVIEW
      ${hasManagerFilter ? `<span class="co-manager">Manager: ${managerName}</span>` : ""}
    </div>
  </div>

  <div class="print-header">Transaction Overview — ${fmtDate(date)}</div>

  <div class="print-columns">
    <div class="print-col">
      <div class="print-section-title">Sales</div>

      <div class="print-row"><span class="label">Sales</span><span>₹ ${fmtCur(responseData?.sales)}</span></div>
      ${rowsHtml(salesData)}

      <div class="print-row"><span class="label">PO Sales</span><span>₹ ${fmtCur(responseData?.po_sales)}</span></div>
      ${rowsHtml(poSalesData)}

      <div class="print-row"><span class="label">Old Sales</span><span>₹ ${fmtCur(responseData?.old_sales)}</span></div>
      ${rowsHtml(oldSalesData)}

      <div class="print-row"><span class="label">Sales Balance</span><span>₹ ${fmtCur(responseData?.sales_balance)}</span></div>
      ${rowsHtml(salesBalanceData)}

      <div class="print-row"><span class="label">Retailer Balance</span><span>₹ ${fmtCur(responseData?.retailer_balance)}</span></div>
      ${rowsHtml(retailerBalanceData)}

      <div class="print-row"><span class="label">Order Advance</span><span>₹ ${fmtCur(responseData?.order_advance)}</span></div>
      ${rowsHtml(orderAdvanceData)}

      <div class="print-row"><span class="label">Order Complete</span><span>₹ ${fmtCur(responseData?.order_complete)}</span></div>
      ${rowsHtml(orderCompleteData)}

      ${addData.l_s_repair_value1 ? `<div class="print-row"><span class="label">L.S. Repair</span><span>₹ ${fmtCur(addData.l_s_repair_value1)}</span></div>` : ""}
      ${addData.l_s_repair_text && addData.l_s_repair_value2 ? `<div class="print-row"><span class="label">${addData.l_s_repair_text}</span><span>₹ ${fmtCur(addData.l_s_repair_value2)}</span></div>` : ""}

      <div class="print-total"><span>Total</span><span>₹ ${fmtCur(responseData?.sales_total)}</span></div>
    </div>

    <div class="print-col">
      <div class="print-section-title">Expense</div>

      <div class="print-row"><span class="label">Exchange</span><span>₹ ${fmtCur(responseData?.exchange)}</span></div>
      ${rowsHtml(exchangeData)}

      <div class="print-row"><span class="label">G Pay</span><span>₹ ${fmtCur(responseData?.gpay)}</span></div>
      ${gpayRowsHtml}

      <div class="print-row"><span class="label">Expense</span><span>₹ ${fmtCur(responseData?.expense)}</span></div>
      ${expenseRowsHtml}

      <div class="print-row"><span class="label">Loan Closed List</span><span>₹ ${fmtCur(responseData?.loan_closed_list ?? loanData.reduce((s, l) => s + parseFloat(l.loan_amount || 0), 0))}</span></div>
      ${loanRowsHtml}

      <div class="print-row"><span class="label">Chit Closed List</span><span>₹ ${fmtCur(responseData?.chit_closed_list ?? chitData.reduce((s, c) => s + parseFloat(c.amount || 0), 0))}</span></div>
      ${chitRowsHtml}

      <div class="print-row"><span class="label">Amount Staff → Manager</span><span>₹ ${fmtCur(addData.amount_staff)}</span></div>
      <div class="print-row"><span class="label">Amount in Cash</span><span>₹ ${fmtCur(addData.amount_in_cash)}</span></div>

      <div class="print-total"><span>Total</span><span>₹ ${fmtCur(responseData?.expense_total)}</span></div>
    </div>
  </div>

</body>
</html>`;

  w.document.open();
  w.document.write(html);
  w.document.close();

  w.onload = () => {
    w.focus();
    w.print();
  };
};

  const [addData, setAddData] = useState({
    l_s_repair_text: "", l_s_repair_value1: "", l_s_repair_value2: "",
    amount_in_cash: "", amount_staff: "", date, created_by: "", created_date: "",
  });

  const fetchExchangeData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/sales.php`, { params: { date } });
      const allSales = hasManagerFilter
        ? (response.data?.data || []).filter((s) => s.manager === managerFilter)
        : (response.data?.data || []);
      const exchangeRows = [];
      allSales.forEach((sale) => {
        (sale.item_list || []).forEach((item) => {
          if ((item.action_type || "").trim().toLowerCase() === "old sales") {
            exchangeRows.push({
              sale_id: sale.sales_no,
              customer_name: sale.customer_name || sale.customer_data?.customer_name || "-",
              item_name: item.item_name_english || item.item || "-",
              weight: item.weight || "-",
              rate: item.rate || "-",
              amount: item.amount || 0,
            });
          }
        });
      });
      setExchangeData(exchangeRows);
    } catch (error) {
      console.error("Error fetching exchange data:", error.message);
      setExchangeData([]);
    }
  };

  // ── Retailer Balance — retailer_details.php aggregates `close` per date.
  // NOTE: this endpoint expects the date as dd-mm-yyyy, unlike every other endpoint here. ──
  const fetchRetailerBalanceData = async () => {
    try {
      const [y, m, d] = date.split("-");
      const ddmmyyyy = `${d}-${m}-${y}`;
      const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`, { params: { date: ddmmyyyy } });
      const all = response.data?.data || [];
      const rows = all.map((r) => ({
        sale_id: r.retailer_id,
        customer_name: r.supplier_details?.name || "-",
        item_name: "-",
        weight: "-",
        rate: "-",
        amount: r.close,
      }));
      setRetailerBalanceData(rows);
    } catch (error) {
      console.error("Error fetching retailer balance data:", error.message);
      setRetailerBalanceData([]);
    }
  };

  // ── Order Advance / Order Complete — both come from orders.php, split by
  // order_date (advance) vs confirmed delivery_date (complete), matching the
  // same logic sales_vs_expense.php uses to compute the summary totals above. ──
  const fetchOrdersData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/orders.php`, { params: { date } });
      const allOrders = response.data?.data || [];
      const all = hasManagerFilter
        ? allOrders.filter((o) => o.manager_name === managerFilter)
        : allOrders;

      const advanceRows = all
        .filter((o) => (o.order_date || "").substring(0, 10) === date)
        .map((o) => ({
          sale_id: o.order_no,
          customer_name: o.customer_info?.name || "-",
          item_name: "-",
          weight: "-",
          rate: "-",
          amount: o.advance_amount,
        }));

      const completeRows = all
        .filter((o) => (o.delivery_status || "").toLowerCase() === "confirm" && (o.delivery_date || "").substring(0, 10) === date)
        .map((o) => ({
          sale_id: o.order_no,
          customer_name: o.customer_info?.name || "-",
          item_name: "-",
          weight: "-",
          rate: "-",
          amount: o.paid,
        }));

      setOrderAdvanceData(advanceRows);
      setOrderCompleteData(completeRows);
    } catch (error) {
      console.error("Error fetching orders data:", error.message);
      setOrderAdvanceData([]);
      setOrderCompleteData([]);
    }
  };

  useEffect(() => {
    fetchData(); fetchSalesData(); fetchExpenseData();
    fetchGpayData(); fetchLoanData(); fetchChitData(); fetchExchangeData();
    fetchRetailerBalanceData(); fetchOrdersData();
  }, [date]);

  useEffect(() => {
    const totalAmount = payments.reduce((sum, p) => sum + parseFloat(p.paid_amount || 0), 0).toFixed(2);
    setAddData((prev) => ({ ...prev, amount_staff: totalAmount }));
  }, [payments]);

  const fetchData = async () => {
    try {
      const params = hasManagerFilter ? { date, manager: managerFilter } : { date };
      const response = await axios.get(`${ApiUrl}/Api/sales_vs_expense.php`, { params });
      if (Array.isArray(response.data?.managers)) {
        setAllManagers(response.data.managers);
      }
      if (response.data.status && response.data.data && response.data.data.length > 0) {
        const record =
          response.data.data.find((item) => item.date === date) ||
          response.data.data.find((item) => {
            const normalized = item.date?.includes("T") ? item.date.split("T")[0] : item.date?.substring(0, 10);
            return normalized === date;
          }) || response.data.data[0];
        if (record) {
          setResponseData(record);
          setPayments(record.payment_data || []);
          setAddData({
            l_s_repair_text: record.l_s_repair_text || "",
            l_s_repair_value1: record.l_s_repair_value1 || "",
            l_s_repair_value2: record.l_s_repair_value2 || "",
            amount_in_cash: record.amount_in_cash || "",
            amount_staff: record.amount_staff || "",
            date: record.date,
            created_by: record.created_by || "",
            created_date: record.created_date || "",
          });
        } else { resetForm(); }
      } else { resetForm(); }
    } catch (error) { console.error("Error fetching data:", error.message); resetForm(); }
  };

  const resetForm = () => {
    setResponseData(null); setPayments([]);
    setAddData({ l_s_repair_text: "", l_s_repair_value1: "", l_s_repair_value2: "", amount_in_cash: "", amount_staff: "", date, created_by: "", created_date: "" });
  };

  const fetchSalesData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/sales.php`, { params: { date } });
      const allSales = response.data?.data || [];
      setResponseSalesData(hasManagerFilter ? allSales.filter((s) => s.manager === managerFilter) : allSales);
    } catch (error) { console.error("Error fetching sales data:", error.message); setResponseSalesData([]); }
  };

  const fetchExpenseData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/expense.php`, { params: { date } });
      const all = response.data?.data || [];
      setExpenseData(all.filter((e) => (e.date || "").substring(0, 10) === date));
    } catch (error) { console.error("Error fetching expense data:", error.message); setExpenseData([]); }
  };

  const fetchGpayData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/sales.php`, { params: { date } });
      const allSales = hasManagerFilter
        ? (response.data?.data || []).filter((s) => s.manager === managerFilter)
        : (response.data?.data || []);
      const gpayRows = [];
      allSales.forEach((sale) => {
        const cName = sale.customer_name || sale.customer_data?.customer_name || "-";
        (sale.payment_history || []).forEach((ph) => {
          if (ph.payment_type && ph.payment_type.toLowerCase() !== "cash") {
            gpayRows.push({ sale_id: sale.sales_no, customer_name: cName, value: ph.amount, txn_date: ph.date || sale.sales_date, pay_type: ph.payment_type });
          }
        });
      });
      setGpayData(gpayRows);
    } catch (error) { console.error("Error fetching gpay data:", error.message); setGpayData([]); }
  };

  const fetchLoanData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/loan.php`);
      const all = response.data?.data || [];
      setLoanData(all.filter((l) => (l.loan_status || "").toLowerCase() === "close" && (l.loan_close_date || "").substring(0, 10) === date));
    } catch (error) { console.error("Error fetching loan data:", error.message); setLoanData([]); }
  };

  const fetchChitData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/chit_list.php`);
      const all = response.data?.data || [];
      setChitData(all.filter((c) => (c.status || "").toLowerCase() === "close" && (c.close_date || "").substring(0, 10) === date));
    } catch (error) { console.error("Error fetching chit data:", error.message); setChitData([]); }
  };

  const handleSubmitData = async () => {
    try {
      const { l_s_repair_text, l_s_repair_value1, l_s_repair_value2, amount_in_cash } = addData;
      if (!l_s_repair_text && !l_s_repair_value1 && !l_s_repair_value2 && !amount_in_cash) {
        alert("Please fill at least one field."); return;
      }
      const formData = {
        l_s_repair_text: l_s_repair_text || "", l_s_repair_value1: l_s_repair_value1 || "",
        l_s_repair_value2: l_s_repair_value2 || "", amount_in_cash: amount_in_cash || "",
        amount_staff: addData.amount_staff || "", date,
        created_by: addData.created_by || "", created_date: addData.created_date || new Date().toISOString(),
        updated_by: "", updated_date: new Date().toISOString(),
      };
      let response;
      if (!responseData) {
        response = await axios.post(`${ApiUrl}/Api/sales_collection.php`, formData, { headers: { "Content-Type": "application/json" } });
      } else {
        response = await axios.put(`${ApiUrl}/Api/sales_collection.php?date=${date}`, formData, { headers: { "Content-Type": "application/json" } });
      }
      navigate("/sales-vs-expense");
      if (response.data.status) { alert(!responseData ? "Data created successfully!" : "Data updated successfully!"); fetchData(); }
      else { throw new Error(response.data.message || "Failed to save data"); }
    } catch (error) { console.error("Error saving data:", error.message); alert(`Error saving data: ${error.message}`); }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!paymentManager) {
        alert("Please select which manager is giving this amount"); return;
      }
      if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
        alert("Please select a payment type and enter a valid amount"); return;
      }
      const paymentData = {
        date, pay_type: paymentType, paid_amount: parseFloat(paymentAmount).toFixed(2), manager: paymentManager,
        created_by: "", created_date: new Date().toISOString(), updated_by: "", updated_date: "",
      };
      const response = await axios.post(`${ApiUrl}/Api/sales_vs_expense_payment.php`, paymentData, { headers: { "Content-Type": "application/json" } });
      if (response.data.status) {
        alert("Payment submitted successfully!"); setPaymentAmount(""); setPaymentType(""); setPaymentManager(""); closePaymentModal(); fetchData();
      } else { throw new Error(response.data.message || "Failed to submit payment"); }
    } catch (error) { console.error("Error submitting payment:", error.message); alert(`Error submitting payment: ${error.message}`); }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const d = new Date(dateString);
      if (isNaN(d.getTime())) return dateString;
      return `${String(d.getDate()).padStart(2,"0")}-${String(d.getMonth()+1).padStart(2,"0")}-${d.getFullYear()}`;
    } catch { return dateString; }
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "0";
    return Number(value).toLocaleString("en-IN");
  };

  const customerName = (sale) => sale.customer_name || sale.customer_data?.customer_name || "-";

  // ── Generic helper to pull line-item rows out of sales data by action_type,
  // formatted consistently as: S.No, Sale ID, Customer, Item, Weight, Rate, Amount ──
  const getItemsByActionType = (typeLabel) => {
    const rows = [];
    responseSalesData.forEach((sale) => {
      (sale.item_list || []).forEach((item) => {
        if ((item.action_type || "").trim().toLowerCase() === typeLabel.toLowerCase()) {
          rows.push({
            sale_id: sale.sales_no,
            customer_name: customerName(sale),
            item_name: item.item_name_english || item.item || "-",
            weight: item.weight || "-",
            rate: item.rate || "-",
            amount: parseFloat(sale.net_total) || 0,
          });
        }
      });
    });
    return rows;
  };

  // ── Sales / PO Sales / Old Sales are genuine sales_items.action_type rows,
  // so they stay driven off the item-level helper. ──
  const salesData    = getItemsByActionType("new");
  const poSalesData  = getItemsByActionType("po-sale");
  const oldSalesData = getItemsByActionType("old sales");

  // ── Sales Balance is NOT an action_type — it's the row-level `balance`
  // field on each sale itself (same field sales_vs_expense.php sums for
  // the `sales_balance` total shown above this table). No extra API call
  // needed since responseSalesData already carries every sales column. ──
  const salesBalanceData = responseSalesData
    .filter((sale) => parseFloat(sale.balance) > 0)
    .map((sale) => ({
      sale_id: sale.sales_no,
      customer_name: customerName(sale),
      item_name: "-",
      weight: "-",
      rate: "-",
      amount: sale.balance,
    }));

  // ── Paid to Customer (refund) — same idea as Sales Balance above, but for
  // the `refund_amount` column: the amount handed back to the customer when
  // an exchanged item's value exceeds the sale total. Shown under Expense,
  // not Sales, since it's money going out rather than sales revenue. ──
  const refundData = responseSalesData
    .filter((sale) => parseFloat(sale.refund_amount) > 0)
    .map((sale) => ({
      sale_id: sale.sales_no,
      customer_name: customerName(sale),
      item_name: sale.refund_pay_type || "-",
      weight: "-",
      rate: "-",
      amount: sale.refund_amount,
    }));

  // retailerBalanceData, orderAdvanceData, orderCompleteData come from state
  // (populated by fetchRetailerBalanceData / fetchOrdersData above).

  const ToggleBtn = ({ show, onClick }) => (
    <button className="btn btn-sm btn-success" onClick={onClick}>
      <i className={`fa-solid fa-${show ? "minus" : "plus"}`}></i>
    </button>
  );

  const NoData = ({ cols, msg }) => (
    <tr><td colSpan={cols} className="text-center text-muted">{msg}</td></tr>
  );

  // ── Reusable item-level table renderer: S.No, Sale ID, Customer Name, Item Name, Weight, Rate, Amount ──
  const ItemTable = ({ data, emptyMsg }) => (
    <div className="mt-2 table-responsive">
      <table className="table table-bordered table-sm">
        <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Item Name</th><th>Weight</th><th>Rate</th><th>Amount</th></tr></thead>
        <tbody>{data.length > 0 ? data.map((e,i) => (
          <tr key={i}><td>{i+1}</td><td>{e.sale_id||"-"}</td><td>{e.customer_name||"-"}</td><td>{e.item_name||"-"}</td><td>{e.weight||"-"}</td><td>₹ {formatCurrency(e.rate)}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
        )) : <NoData cols={7} msg={emptyMsg} />}</tbody>
      </table>
    </div>
  );

  const PrintItemTable = ({ data }) => (
    data.length > 0 && (
      <table><thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Item</th><th>Wt</th><th>Rate</th><th>Amt</th></tr></thead>
      <tbody>{data.map((e,i)=>(
        <tr key={i}><td>{i+1}</td><td>{e.sale_id}</td><td>{e.customer_name}</td><td>{e.item_name}</td><td>{e.weight}</td><td>₹{formatCurrency(e.rate)}</td><td>₹{formatCurrency(e.amount)}</td></tr>
      ))}</tbody></table>
    )
  );

  return (
    <div className="container-fluid pb-5">
      <div className="card shadow-sm ">
        <div className="card-body">
          <div className="container-fluid">
            <div className="card rounded-3 p-3 print-area" style={{ backgroundColor: "#D5F1F1" }}>

              {/* ── PRINT COMPANY HEADER ── */}
              <div className="print-company-header">
                <img
                  src={companyLogo}
                  alt="Logo"
                  width="100" height="55"
                  className="co-logo"
                  onError={(e) => { e.target.style.display = "none"; }}
                />
                <div className="co-details">
                  <h2>TIRUPUR JEWELLERY</h2>
                  <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
                  <p>Ph: 04272233807</p>
                </div>
                <div className="co-title">
                  TXN OVERVIEW
                  {hasManagerFilter && (
                    <span className="co-manager">Manager: {managerName}</span>
                  )}
                </div>
              </div>

              {/* ── PRINT DATE HEADER ── */}
              <div className="print-header">
                Transaction Overview — {formatDate(date)}
              </div>

              {/* ── SCREEN TITLE (manager badge in the top-right corner) ── */}
              <div className="d-flex justify-content-between align-items-center mb-3 no-print">
                <div style={{ width: "160px" }}></div>
                <h5 className="text-center text-black border-0 mb-0 flex-grow-1">
                  Transaction Overview — {formatDate(date)}
                </h5>
                <div style={{ width: "160px" }} className="text-end">
                  {hasManagerFilter && (
                    <span className="badge bg-primary px-3 py-2">
                      Manager: {managerName}
                    </span>
                  )}
                </div>
              </div>

              {/* ── PRINT LAYOUT ── */}
              <div className="print-columns">

                {/* LEFT: Sales */}
                <div className="print-col">
                  <div className="print-section-title">Sales</div>

                  <div className="print-row"><span className="label">Sales</span><span>₹ {formatCurrency(responseData?.sales)}</span></div>
                  <PrintItemTable data={salesData} />

                  <div className="print-row"><span className="label">PO Sales</span><span>₹ {formatCurrency(responseData?.po_sales)}</span></div>
                  <PrintItemTable data={poSalesData} />

                  <div className="print-row"><span className="label">Old Sales</span><span>₹ {formatCurrency(responseData?.old_sales)}</span></div>
                  <PrintItemTable data={oldSalesData} />

                  {/* ── Sales Balance ── */}
                  <div className="print-row"><span className="label">Sales Balance</span><span>₹ {formatCurrency(responseData?.sales_balance)}</span></div>
                  <PrintItemTable data={salesBalanceData} />

                  {/* ── Retailer Balance ── */}
                  <div className="print-row"><span className="label">Retailer Balance</span><span>₹ {formatCurrency(responseData?.retailer_balance)}</span></div>
                  <PrintItemTable data={retailerBalanceData} />

                  {/* ── Order Advance ── */}
                  <div className="print-row"><span className="label">Order Advance</span><span>₹ {formatCurrency(responseData?.order_advance)}</span></div>
                  <PrintItemTable data={orderAdvanceData} />

                  {/* ── Order Complete ── */}
                  <div className="print-row"><span className="label">Order Complete</span><span>₹ {formatCurrency(responseData?.order_complete)}</span></div>
                  <PrintItemTable data={orderCompleteData} />

                  {addData.l_s_repair_value1 && <div className="print-row"><span className="label">L.S. Repair</span><span>₹ {formatCurrency(addData.l_s_repair_value1)}</span></div>}
                  {addData.l_s_repair_text && addData.l_s_repair_value2 && <div className="print-row"><span className="label">{addData.l_s_repair_text}</span><span>₹ {formatCurrency(addData.l_s_repair_value2)}</span></div>}
                  <div className="print-total"><span>Total</span><span>₹ {formatCurrency(responseData?.sales_total)}</span></div>
                </div>

                {/* RIGHT: Expense */}
                <div className="print-col">
                  <div className="print-section-title">Expense</div>

                  <div className="print-row"><span className="label">Exchange</span><span>₹ {formatCurrency(responseData?.exchange)}</span></div>
                  {exchangeData.length > 0 && (
                    <table><thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Item</th><th>Wt</th><th>Rate</th><th>Amt</th></tr></thead>
                    <tbody>{exchangeData.map((e,i)=>(
                      <tr key={i}><td>{i+1}</td><td>{e.sale_id}</td><td>{e.customer_name}</td><td>{e.item_name}</td><td>{e.weight}</td><td>₹{formatCurrency(e.rate)}</td><td>₹{formatCurrency(e.amount)}</td></tr>
                    ))}</tbody></table>
                  )}

                  <div className="print-row"><span className="label">Paid to Customer</span><span>₹ {formatCurrency(responseData?.refund_to_customer)}</span></div>
                  <PrintItemTable data={refundData} />

                  <div className="print-row"><span className="label">G Pay</span><span>₹ {formatCurrency(responseData?.gpay)}</span></div>
                  {gpayData.length > 0 && (
                    <table><thead><tr><th>S.No</th><th>Sale ID</th><th>Customer</th><th>Type</th><th>Date</th><th>Value</th></tr></thead>
                    <tbody>{gpayData.map((g,i)=>(
                      <tr key={i}><td>{i+1}</td><td>{g.sale_id}</td><td>{g.customer_name}</td><td>{g.pay_type}</td><td>{formatDate(g.txn_date)}</td><td>₹{formatCurrency(g.value)}</td></tr>
                    ))}</tbody></table>
                  )}

                  <div className="print-row"><span className="label">Expense</span><span>₹ {formatCurrency(responseData?.expense)}</span></div>
                  {expenseData.length > 0 && (
                    <table><thead><tr><th>S.No</th><th>Exp No</th><th>Type</th><th>Description</th><th>Date</th><th>Amount</th></tr></thead>
                    <tbody>{expenseData.map((e,i)=>(
                      <tr key={i}><td>{i+1}</td><td>{e.id}</td><td>{e.type}</td><td>{e.description}</td><td>{formatDate(e.date)}</td><td>₹{formatCurrency(e.amount)}</td></tr>
                    ))}</tbody></table>
                  )}

                  <div className="print-row"><span className="label">Loan Closed List</span><span>₹ {formatCurrency(responseData?.loan_closed_list ?? loanData.reduce((s,l)=>s+parseFloat(l.loan_amount||0),0))}</span></div>
                  {loanData.length > 0 && (
                    <table><thead><tr><th>S.No</th><th>Loan ID</th><th>Customer</th><th>Category</th><th>Amount</th></tr></thead>
                    <tbody>{loanData.map((l,i)=>(
                      <tr key={i}><td>{i+1}</td><td>{l.loan_id}</td><td>{l.customer?.customer_name||"-"}</td><td>{l.loan_list?.[0]?.category||"-"}</td><td>₹{formatCurrency(l.loan_amount)}</td></tr>
                    ))}</tbody></table>
                  )}

                  <div className="print-row"><span className="label">Chit Closed List</span><span>₹ {formatCurrency(responseData?.chit_closed_list ?? chitData.reduce((s,c)=>s+parseFloat(c.amount||0),0))}</span></div>
                  {chitData.length > 0 && (
                    <table><thead><tr><th>S.No</th><th>Chit ID</th><th>Customer</th><th>Duration</th><th>Amount</th></tr></thead>
                    <tbody>{chitData.map((c,i)=>(
                      <tr key={i}><td>{i+1}</td><td>{c.chit_id}</td><td>{c.name||"-"}</td><td>{c.duration}</td><td>₹{formatCurrency(c.amount)}</td></tr>
                    ))}</tbody></table>
                  )}

                  <div className="print-row"><span className="label">Amount Staff → Manager</span><span>₹ {formatCurrency(addData.amount_staff)}</span></div>
                  <div className="print-row"><span className="label">Amount in Cash</span><span>₹ {formatCurrency(addData.amount_in_cash)}</span></div>
                  <div className="print-total"><span>Total</span><span>₹ {formatCurrency(responseData?.expense_total)}</span></div>
                </div>
              </div>

              {/* ── SCREEN LAYOUT ── */}
              <div className="row no-print">

                {/* SALES SIDE */}
                <div className="col-lg-6">
                  <div className="card p-4">
                    <h6 className="text-primary mb-4">Sales</h6>

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Sales</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.sales)}</div>
                        <ToggleBtn show={showSalesTable} onClick={() => setShowSalesTable(!showSalesTable)} />
                      </div>
                    </div>
                    {showSalesTable && <ItemTable data={salesData} emptyMsg="No sales data available" />}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">PO Sales</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.po_sales)}</div>
                        <ToggleBtn show={showPoSalesTable} onClick={() => setShowPoSalesTable(!showPoSalesTable)} />
                      </div>
                    </div>
                    {showPoSalesTable && <ItemTable data={poSalesData} emptyMsg="No PO sales data available" />}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Old Sales</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.old_sales)}</div>
                        <ToggleBtn show={showOldSalesTable} onClick={() => setShowOldSalesTable(!showOldSalesTable)} />
                      </div>
                    </div>
                    {showOldSalesTable && <ItemTable data={oldSalesData} emptyMsg="No old sales data available" />}

                    {/* ── Sales Balance ── */}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Sales Balance</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.sales_balance)}</div>
                        <ToggleBtn show={showSalesBalanceTable} onClick={() => setShowSalesBalanceTable(!showSalesBalanceTable)} />
                      </div>
                    </div>
                    {showSalesBalanceTable && <ItemTable data={salesBalanceData} emptyMsg="No sales balance data available" />}

                    {/* ── Retailer Balance ── */}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Retailer Balance</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.retailer_balance)}</div>
                        <ToggleBtn show={showRetailerBalanceTable} onClick={() => setShowRetailerBalanceTable(!showRetailerBalanceTable)} />
                      </div>
                    </div>
                    {showRetailerBalanceTable && <ItemTable data={retailerBalanceData} emptyMsg="No retailer balance data available" />}

                    {/* ── Order Advance ── */}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Order Advance</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.order_advance)}</div>
                        <ToggleBtn show={showOrderAdvanceTable} onClick={() => setShowOrderAdvanceTable(!showOrderAdvanceTable)} />
                      </div>
                    </div>
                    {showOrderAdvanceTable && <ItemTable data={orderAdvanceData} emptyMsg="No order advance data available" />}

                    {/* ── Order Complete ── */}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Order Complete</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.order_complete)}</div>
                        <ToggleBtn show={showOrderCompleteTable} onClick={() => setShowOrderCompleteTable(!showOrderCompleteTable)} />
                      </div>
                    </div>
                    {showOrderCompleteTable && <ItemTable data={orderCompleteData} emptyMsg="No order complete data available" />}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">L.S. Repair</span>
                      <input type="text" className="form-control" placeholder="Enter Value" value={addData.l_s_repair_value1} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, l_s_repair_value1: e.target.value })} />
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <input type="text" className="form-control" placeholder="Enter Text" value={addData.l_s_repair_text} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, l_s_repair_text: e.target.value })} />
                      <input type="text" className="form-control" placeholder="Enter Value" value={addData.l_s_repair_value2} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, l_s_repair_value2: e.target.value })} />
                    </div>

                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Total</span>
                      <div className="border rounded px-3 py-1 text-end" style={{ width: "180px" }}>₹ {formatCurrency(responseData?.sales_total)}</div>
                    </div>
                  </div>
                </div>

                {/* EXPENSE SIDE */}
                <div className="col-lg-6">
                  <div className="card h-100 p-3">
                    <h6 className="text-primary mb-4">Expense</h6>

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Exchange</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.exchange)}</div>
                        <ToggleBtn show={showExchangeTable} onClick={() => setShowExchangeTable(!showExchangeTable)} />
                      </div>
                    </div>
                    {showExchangeTable && (
                      <div className="mt-2 table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Item Name</th><th>Weight</th><th>Rate</th><th>Amount</th></tr></thead>
                          <tbody>{exchangeData.length > 0 ? exchangeData.map((e,i) => (
                            <tr key={i}><td>{i+1}</td><td>{e.sale_id||"-"}</td><td>{e.customer_name||"-"}</td><td>{e.item_name||"-"}</td><td>{e.weight||"-"}</td><td>₹ {formatCurrency(e.rate)}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
                          )) : <NoData cols={7} msg="No exchange data available" />}</tbody>
                        </table>
                      </div>
                    )}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Paid to Customer</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.refund_to_customer)}</div>
                        <ToggleBtn show={showRefundTable} onClick={() => setShowRefundTable(!showRefundTable)} />
                      </div>
                    </div>
                    {showRefundTable && (
                      <div className="mt-2 table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Pay Type</th><th>Weight</th><th>Rate</th><th>Amount</th></tr></thead>
                          <tbody>{refundData.length > 0 ? refundData.map((e,i) => (
                            <tr key={i}><td>{i+1}</td><td>{e.sale_id||"-"}</td><td>{e.customer_name||"-"}</td><td>{e.item_name||"-"}</td><td>{e.weight||"-"}</td><td>{e.rate||"-"}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
                          )) : <NoData cols={7} msg="No refund data available" />}</tbody>
                        </table>
                      </div>
                    )}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">G Pay</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.gpay)}</div>
                        <ToggleBtn show={showGpayTable} onClick={() => setShowGpayTable(!showGpayTable)} />
                      </div>
                    </div>
                    {showGpayTable && (
                      <div className="mt-2 table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light"><tr><th>S.No</th><th>Sale ID</th><th>Customer Name</th><th>Pay Type</th><th>Txn Date</th><th>Value</th></tr></thead>
                          <tbody>{gpayData.length > 0 ? gpayData.map((g,i) => (
                            <tr key={i}><td>{i+1}</td><td>{g.sale_id||"-"}</td><td>{g.customer_name||"-"}</td><td>{g.pay_type||"-"}</td><td>{formatDate(g.txn_date)||"-"}</td><td>₹ {formatCurrency(g.value)}</td></tr>
                          )) : <NoData cols={6} msg="No G Pay data available" />}</tbody>
                        </table>
                      </div>
                    )}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Expense</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.expense)}</div>
                        <ToggleBtn show={showExpenseTable} onClick={() => setShowExpenseTable(!showExpenseTable)} />
                      </div>
                    </div>
                    {showExpenseTable && (
                      <div className="mt-2 table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light"><tr><th>S.No</th><th>Expense No</th><th>Type</th><th>Description</th><th>Exp Date</th><th>Amount</th></tr></thead>
                          <tbody>{expenseData.length > 0 ? expenseData.map((e,i) => (
                            <tr key={i}><td>{i+1}</td><td>{e.id||"-"}</td><td>{e.type||"-"}</td><td>{e.description||"-"}</td><td>{formatDate(e.date)||"-"}</td><td>₹ {formatCurrency(e.amount)}</td></tr>
                          )) : <NoData cols={6} msg="No expense data available" />}</tbody>
                        </table>
                      </div>
                    )}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Loan Closed List</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.loan_closed_list ?? loanData.reduce((s,l)=>s+parseFloat(l.loan_amount||0),0))}</div>
                        <ToggleBtn show={showLoanTable} onClick={() => setShowLoanTable(!showLoanTable)} />
                      </div>
                    </div>
                    {showLoanTable && (
                      <div className="mt-2 table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light"><tr><th>S.No</th><th>Loan ID</th><th>Customer Name</th><th>Category</th><th>Loan Amount</th></tr></thead>
                          <tbody>{loanData.length > 0 ? loanData.map((l,i) => (
                            <tr key={i}><td>{i+1}</td><td>{l.loan_id||"-"}</td><td>{l.customer?.customer_name||"-"}</td><td>{l.loan_list?.[0]?.category||"-"}</td><td>₹ {formatCurrency(l.loan_amount)}</td></tr>
                          )) : <NoData cols={5} msg="No loan data available" />}</tbody>
                        </table>
                      </div>
                    )}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Chit Closed List</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.chit_closed_list ?? chitData.reduce((s,c)=>s+parseFloat(c.amount||0),0))}</div>
                        <ToggleBtn show={showChitTable} onClick={() => setShowChitTable(!showChitTable)} />
                      </div>
                    </div>
                    {showChitTable && (
                      <div className="mt-2 table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light"><tr><th>S.No</th><th>Chit ID</th><th>Customer Name</th><th>Duration</th><th>Amount</th></tr></thead>
                          <tbody>{chitData.length > 0 ? chitData.map((c,i) => (
                            <tr key={i}><td>{i+1}</td><td>{c.chit_id||"-"}</td><td>{c.name||"-"}</td><td>{c.duration||"-"}</td><td>₹ {formatCurrency(c.amount)}</td></tr>
                          )) : <NoData cols={5} msg="No chit data available" />}</tbody>
                        </table>
                      </div>
                    )}

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <div><span className="fw-bold">Amount</span><br /><span className="small">Manager <i className="fa-solid fa-arrow-right"></i> Admin</span></div>
                      <div className="d-flex align-items-center" style={{ width: "250px" }}>
                        <input type="text" className="form-control mt-3" placeholder="Amount" value={addData.amount_staff} disabled />
                        <button className="btn btn-success ms-2" onClick={openPaymentModal}>+</button>
                        <button className="btn btn-light ms-1 border" onClick={openInfoModal}><i className="bi bi-info-circle"></i></button>
                      </div>
                    </div>

                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Amount in Cash</span>
                      <input type="text" className="form-control" placeholder="Enter Amount" value={addData.amount_in_cash} style={{ width: "180px" }} onChange={(e) => setAddData({ ...addData, amount_in_cash: e.target.value })} />
                    </div>

                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Total</span>
                      <div className="border rounded px-3 py-2 text-end">₹ {formatCurrency(responseData?.expense_total)}</div>
                    </div>

                    {/* Action Buttons */}
                    <div className="row mt-4 no-print">
                      <div className="col-12 d-flex justify-content-end gap-2">
                        <button className="btn btn-sm btn-secondary" onClick={() => navigate("/sales-vs-expense")}>
                          <i className="fa-solid fa-arrow-left me-1"></i> Back
                        </button>
                        <button className="btn btn-sm btn-primary" onClick={handleSubmitData}>
                          <i className="fa-solid fa-floppy-disk me-1"></i>
                          {responseData ? "Update" : "Save"}
                        </button>
                        <button className="btn btn-sm btn-info text-white" onClick={handlePrint}>
                          <i className="fa-solid fa-print me-1"></i> Print
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Add Payment Modal */}
          <div className={`modal fade ${paymentModal ? "show" : ""}`} style={{ display: paymentModal ? "block" : "none" }} tabIndex="-1" aria-hidden={!paymentModal}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h6 className="modal-title text-primary">Add Payment</h6>
                  <button type="button" className="btn-close" style={{ fontSize: "10px" }} onClick={closePaymentModal}></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handlePaymentSubmit}>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="mb-3">
                          <label>Manager</label>
                          <select className="form-select" value={paymentManager} onChange={(e) => setPaymentManager(e.target.value)}>
                            <option value="">Select Manager</option>
                            {allManagers.map((m) => (
                              <option key={m} value={m}>{m}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="mb-3">
                          <label>Pay Type</label>
                          <select className="form-select" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                            <option value="">Select Paytype</option>
                            <option value="cash">Cash</option>
                            <option value="gpay">Gpay</option>
                            <option value="phonepe">Phonepe</option>
                            <option value="paytm">Paytm</option>
                            <option value="credit">Credit</option>
                            <option value="debit">Debit</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="mb-3">
                          <label>Enter Amount</label>
                          <input type="number" className="form-control" placeholder="Enter Amount" value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <button type="submit" className="btn btn-primary btn-sm mt-4">Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Payment History Modal */}
          <div className={`modal fade ${infoModal ? "show" : ""}`} style={{ display: infoModal ? "block" : "none" }} tabIndex="-1" aria-hidden={!infoModal}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h6 className="modal-title text-primary">Payment History - {formatDate(date)}</h6>
                  <button type="button" className="btn-close" style={{ fontSize: "10px" }} onClick={closeInfoModal}></button>
                </div>
                <div className="modal-body">
                  <div className="card" style={{ borderRadius: "15px", backgroundColor: "#5c9dff", color: "white" }}>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table text-white">
                          <thead><tr><th>S.No</th><th>Date</th><th>Manager</th><th>Pay Type</th><th>Paid Amount</th></tr></thead>
                          <tbody>
                            {payments.length > 0 ? payments.map((payment, index) => (
                              <tr key={payment.id || index}><td>{index+1}</td><td>{formatDate(payment.date)}</td><td>{payment.manager || "-"}</td><td>{payment.pay_type}</td><td>₹ {formatCurrency(payment.paid_amount)}</td></tr>
                            )) : <tr><td colSpan="5" className="text-center">No payment history available for {formatDate(date)}</td></tr>}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {(paymentModal || infoModal) && (
            <div className="modal-backdrop fade show" onClick={() => { closePaymentModal(); closeInfoModal(); }}></div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SalesVsExpense;